const Unauthorized = () => (
  <div style={{ padding: "2rem" }}>
    <h2>Acceso denegado</h2>
    <p>No tienes permiso para ver esta página.</p>
  </div>
);

export default Unauthorized;